import { render, staticRenderFns } from "./AssignLawyerForm.vue?vue&type=template&id=f8c3f6e8&scoped=true"
import script from "./AssignLawyerForm.vue?vue&type=script&lang=js"
export * from "./AssignLawyerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c3f6e8",
  null
  
)

export default component.exports